import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatLocalDate(dateString: string) {
  if (!dateString) return "-";
  // dateString is YYYY-MM-DD
  const [year, month, day] = dateString.split('-').map(Number);
  // Create a date using the components to avoid UTC/local shift
  const date = new Date(year, month - 1, day);
  return date.toLocaleDateString('es-ES');
}
